export var THEME_VARIANTS = {
  DARK: 'dark',
  LIGHT: 'light'
};

// Default Theme Variant
export var DEFAULT_THEME_VARIANT = THEME_VARIANTS.DARK;
export default {
  THEME_VARIANTS: THEME_VARIANTS,
  DEFAULT_THEME_VARIANT: DEFAULT_THEME_VARIANT
};